import axios from "../utils/axios";

export const getAboutHeaderSection = async () => {
    const response = await axios.get('/settings/about-header-page');
    return response.data;
};

export const updateAboutHeaderSection = async (data) => {
    const response = await axios.put('/settings/about-header-page', data);
    return response.data;
};
